import * as ga from "./analytics";

export const trackPage = (page) => {
  ga.trackPage(page);
};

export const trackDownload = (platform, method) => {
  ga.trackDownload(platform, method);
};

export const trackSocial = (network) => {
  ga.trackSocial(network);
};

export const trackGuide = (platform) => {
  ga.trackGuide(platform);
};

export const trackInstallFlow = (platform, action, tab = null) => {
  ga.trackInstallFlow(platform, action, tab);
};

export const trackCarousel = (interaction, index) => {
  ga.trackCarousel(interaction, index);
};